import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import {
  Card,
  CardContent,
  Box,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  InputAdornment,
  IconButton,
  Backdrop,
  Input,
  CircularProgress,
  AppBar,
  Container
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import BenefitsPersonal from './BenefitsPersonal';
import { useClientContext } from '../../context/client_context';
import { useClaimsContext } from '../../context/claims_context';
import { baseUrl } from '../../utils/constants';
import Controls from '../controls/Controls';
import ClaimsView from './ClaimsView';
import ProvidentSubs from '../clients/ProvidentTrans';
import Dependants from '../clients/Dependants';
import ClientNotes from '../clients/ClientNotes';
import ProvidentZwd from '../clients/ProvidentZwd';
import SubsTransactions from '../clients/SubsTransactions';
import SubsTransZim from '../clients/SubsTransZim';
import LoansPortfolio from '../accounting/LoansPortfolio';
import DocumentsMain from '../clients/DocumentsMain';

export default function BenefitsLookUp() {
  const [index, setIndex] = useState(0);
  const { getLimitUsage, getLimitTotalUsage, setClaimDetailsList } = useClaimsContext();
  const {
    dependantList,
    setDependantList,
    currDependant,
    setDependant,
    parentRefId,
    setParentRefId
  } = useClientContext();
  const [memberCode, setMemberCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  useEffect(() => {
    // getMemberInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onTabClicked = (event, index) => {
    setIndex(index);
  };

  const Panel = (props) => <div hidden={props.value !== props.index}>{props.children}</div>;

  const getMemberInfo = async (event) => {
    if (memberCode === '') {
      notifyPopup(`No Employee # Selected, please enter number to seach for!`, 'error');
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/client/GetMembersByFundNo?medFundNo=${memberCode}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Provider not Found!: ${result.replyMessage}`, 'error');
        } else {
          console.log('returned parentRef', result.data.result[0].cif_number);
          console.log('returned members cif', result.data.result[0]);
          setDependant(result.data.result[0]);
          setParentRefId(result.data.result[0].cif_number);
          setDependantList(result.data.result);
          getLimitUsage(result.data.result[0]);
          getLimitTotalUsage(result.data.result[0]);
          setClaimDetailsList([]);
        }
      },
      (error) => {
        notifyPopup(`Error in getMemberInfo!: ${error}`, 'error');
      }
    );
  };

  const populateDependants = async (cifNumber) => {
    if (cifNumber === '') {
      return;
    }
    console.log('dependant cifnumber: ', cifNumber);
    setLoading(true);
    await axios(`${baseUrl}/api/client/GetClientByAfcCifNo?afcNumber=${cifNumber}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Member not Found!: ${result.replyMessage}`, 'error');
        } else {
          console.log('returned member', result);
          console.log('returned member cif', result.data.result);
          // setDependant(result.data.result);
          getLimitUsage(result.data.result);
          getLimitTotalUsage(result.data.result);
        }
      },
      (error) => {
        notifyPopup(`Error in Searching for Member!: ${error}`, 'error');
      }
    );
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <Grid margin={2} container spacing={2} direction="row">
        <Grid item xs={3} sm={3} mr={2}>
          <FormControl>
            <InputLabel htmlFor="memberCodem">Search Members</InputLabel>
            <Input
              id="memberCode"
              type="text"
              value={memberCode}
              onChange={(e) => {
                setMemberCode(e.target.value);
              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onMouseDown={handleMouseDownPassword}
                    onClick={() => getMemberInfo()}
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormControl fullWidth>
            <InputLabel id="deplbl">Dependant/Member</InputLabel>
            <Select
              id="patient_Cif_No"
              name="patient_Cif_No"
              fullWidth
              size="small"
              variant="outlined"
              onChange={(e) => {
                populateDependants(e.target.value);
              }}
            >
              <MenuItem key="" value="">
                Not Selected
              </MenuItem>
              {dependantList.map((item) => (
                <MenuItem key={item.cif_number} value={item.cif_number}>
                  {item.suffix} {item.surname} {item.firstName}{' '}
                  {moment(item.dateOfBirth).isValid()
                    ? moment(item.dateOfBirth).format('YYYY-MM-DD')
                    : ''}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid> */}
      <Card>
        <CardContent>
          <AppBar position="static" color="darkblack">
            <Tabs
              value={index}
              indicatorColor="primary"
              // textColor="white"
              onChange={onTabClicked}
              aria-label="simple tabs example"
            >
              <Tab label="Personal Details" />
              <Tab label="Previous Claims" />
              <Tab label="Loan Portfolio" />
              <Tab label="Dependants" />
              <Tab label="Subs US$" />
              <Tab label="Provident US$" />
              <Tab label="Provident ZWD" />
              <Tab label="Documents" />
              <Tab label="Client Notes" />
            </Tabs>
          </AppBar>
          <Box>.</Box>
          <Panel value={index} index={0}>
            <BenefitsPersonal />
          </Panel>
          <Panel value={index} index={1}>
            {parentRefId > 0 && <ClaimsView />}
          </Panel>
          <Panel value={index} index={2}>
            <LoansPortfolio />
          </Panel>
          <Panel value={index} index={3}>
            <Dependants />
          </Panel>
          <Panel value={index} index={4}>
            <SubsTransactions />
          </Panel>
          {/* <Panel value={index} index={4}>
            <SubsTransZim />
          </Panel> */}
          <Panel value={index} index={5}>
            <ProvidentSubs />
          </Panel>
          <Panel value={index} index={6}>
            <ProvidentZwd />
          </Panel>
          <Panel value={index} index={7}>
            <DocumentsMain />
          </Panel>
          <Panel value={index} index={8}>
            <ClientNotes />
          </Panel>
        </CardContent>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Card>
    </Container>
  );
}
